"use client";
import { useTacticHooks } from "@gettactic/hooks";
import { useQuery } from "@tanstack/react-query";

export const useExternalsQuery = (
  objectId: string,
  objectType?: string,
  type?: string
) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useExternalsQuery", apiClient.slug, objectId],

    queryFn: async () => {
      const res = await apiClient.externals.getExternalIds(
        objectId,
        objectType,
        type
      );
      return res.result;
    }
  });
};
